export type ProjectIconVariant = "primary" | "secondary" | "tertiary";

/** Icônes Lucide (nom du symbole exporté). */
export type ProjectLucideTabIcon =
  | "SquareTerminal"
  | "Atom"
  | "File"
  | "Server"
  | "FileCodeCorner"
  | "ShoppingCart"
  | "Droplet"
  | "Table2"
  | "Bird";

/** Fichiers présents dans `public/images/langages` (sans `.svg`). Ajoute une entrée si tu ajoutes un SVG. */
export const PROJECT_LANG_SVG_IDS = [
  "html5",
  "nextdotjs",
  "supabase",
  "ansible",
  "github",
  "tailwindcss",
  "flutter",
  "vercel",
  "git",
  "pnpm",
  "webflow",
  "javascript",
  "swift",
  "laravel",
  "shopify",
  "wordpress",
  "javascript",
] as const;

export type ProjectLangSvgIcon = (typeof PROJECT_LANG_SVG_IDS)[number];

export type ProjectTabIcon = ProjectLucideTabIcon | ProjectLangSvgIcon;

export type ProjectFolder =
  | "projects"
  | "favorites"
  | "inProgress"
  | "archived";

export type Project = {
  id: string;
  anchor: string;
  fileName: string;
  title: string;
  version: string;
  description: string;
  longDescription?: string;
  screenshots?: string[];
  highlights?: string[];
  tags: string[];
  image: string;
  sourceUrl?: string;
  deployUrl?: string;
  fileIcon: ProjectTabIcon;
  folder: ProjectFolder;
};

export default Project;
